import { FC } from 'react';
import { Link as RouterLink } from 'react-router';
import {
  Tab,
  Tabs,
} from '@mui/material';

import { useRouter } from '@cvt/routing';

import { useMatchedRoute } from '@shared/hooks/useMatchedRoute';


export const ObjectiveVersionTabs: FC = () => {

  const router = useRouter();

  const tabIndex = useMatchedRoute([
    `${router.objectives.current.path}`,
    `${router.objectives.history.path}`,
  ]);

  const activeTab = tabIndex === -1 ? 0 : tabIndex;

  return (
    <Tabs
      value={activeTab}
      variant="fullWidth"
      textColor="primary"
    >
      <Tab label="Current Version" component={RouterLink} to={router.objectives.current.path}/>
      <Tab label="Version History" component={RouterLink} to={router.objectives.history.path}/>
    </Tabs>
  );
};
